import {type UIGameManager} from '../UIGameManager.ts'
import {UIKnightPlacementHoverActionController} from '../ui_game_hover_actions/UIKnightPlacementHoverActionController.ts'
import {UIKnightActivationHoverActionController} from '../ui_game_hover_actions/UIKnightActivationHoverActionController.ts'
import {UIKnightUpgradeHoverActionController} from '../ui_game_hover_actions/UIKnightUpgradeHoverActionController.ts'
import {UIKnightActionHoverActionController} from '../ui_game_hover_actions/UIKnightActionHoverActionController.ts'
import {type MechanicKnightState, type MechanicPirateState, type MechanicRobberState} from '@colonist/game-states'
import {MechanicValidatorKnight, MechanicValidatorKnightActions} from '@colonist/game-mechanic-validators'

export class UIGameKnightController {
    protected readonly uiGameManager: UIGameManager
    readonly knightValidator: MechanicValidatorKnight
    readonly knightActionValidator: MechanicValidatorKnightActions

    constructor(uiGameManager: UIGameManager, knightState: MechanicKnightState, robberState: MechanicRobberState | undefined, pirateState: MechanicPirateState | undefined) {
        this.uiGameManager = uiGameManager

        this.knightValidator = new MechanicValidatorKnight(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, knightState)
        this.knightActionValidator = new MechanicValidatorKnightActions(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, knightState, robberState, pirateState)
        this.initializeHoverActions()
    }

    private initializeHoverActions() {
        if(this.uiGameManager.gameController.isPlayerSpectator) return
        if(this.uiGameManager.gameController.isReplay) return

        const myKnightValidator = this.knightValidator.getKnightPlayerValidator(this.uiGameManager.gameController.myColor)
        new UIKnightPlacementHoverActionController(this.uiGameManager, myKnightValidator)
        new UIKnightUpgradeHoverActionController(this.uiGameManager, myKnightValidator)
        new UIKnightActivationHoverActionController(this.uiGameManager, myKnightValidator)
        new UIKnightActionHoverActionController(this.uiGameManager, this.knightActionValidator)
    }
}
